import styled from 'styled-components';

import { Card, CardContent, ListItem, ListItemText } from './material-ui-styles';

import { List, Typography, ListItemIcon } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { colors } from '@constants';

export type ListItemTypes = {
  id?: number | string;
  label?: string | JSX.Element;
  isDisabled?: boolean;
  isSelected?: boolean;
  className?: string;
  openInNewTab?: boolean;
};

type SimpleListPropsType = {
  listItems: Array<ListItemTypes>;
  listTitle: string;
  listSubtitle: string;
  selectedItem?: ListItemTypes | Record<string, any>;
  isLoading?: boolean;
  handleSelectListItem: (item: Record<any, any>) => void;
};

// Use transient props ($isSelected, $isDisabled) to prevent them from being passed to DOM
const StyledListItem = styled(ListItem)<{ $isSelected?: boolean; $isDisabled?: boolean }>`
  background-color: ${({ $isSelected }) => $isSelected && colors.hoveredButtonGrey};

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  `}

  &.bold {
    opacity: 1;
    .text {
      font-weight: 600;
      font-size: 15px;
    }
  }
  &.divider {
    border-top: 1px solid rgba(224, 224, 224, 1);
  }
  .icon {
    margin-right: 0.3rem;
  }
`;

export default function SimpleList({
  listItems,
  listTitle = 'Simple List',
  listSubtitle = '',
  selectedItem,
  handleSelectListItem,
  isLoading,
}: SimpleListPropsType) {
  return (
    <Card sx={{ mb: 6 }}>
      <CardContent sx={{ pb: 0 }}>
        <Typography variant="h6" gutterBottom>
          {listTitle}
        </Typography>
        {listSubtitle && (
          <Typography variant="body2" gutterBottom>
            {listSubtitle}
          </Typography>
        )}
      </CardContent>
      <List component="nav">
        {listItems &&
          listItems.map((item: ListItemTypes) => {
            const isDisabled = isLoading || item.isDisabled;
            return (
              <StyledListItem
                key={item.id}
                $isSelected={item.id === selectedItem?.id}
                onClick={() => !isDisabled && handleSelectListItem(item)}
                $isDisabled={isDisabled}
                className={item.className}
              >
                {item.openInNewTab && <OpenInNew className="icon" fontSize={'small'} />}
                <ListItemText slotProps={{ primary: { className: 'text' } }} primary={item.label} />
              </StyledListItem>
            );
          })}
      </List>
    </Card>
  );
}
